// extracted by mini-css-extract-plugin
export default {"title":"Cor2wJUmDK"};
    if(module.hot) {
      // 1648554160816
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  